export enum maintenanceTypes {
    MAINTENANCE_DATA = 'MAINTENANCE_DATA'
}